import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import "react-datepicker/dist/react-datepicker.css";
import IconPicker from "../commonViews/IconPicker.jsx";
import "react-notifications/lib/notifications.css";
import {
    NotificationContainer,
    NotificationManager,
} from "react-notifications";
import TableView from "../commonViews/TableView.jsx";
import {
    getTextColor,
    getMainBackground,
    getFontColor,
} from "../../ThemeHandlers/theme";
import { fetchDTCMasterAction } from '../../actions/dtc_actions'
import Metrics from "../commonViews/Metrics.jsx";
import Audits from "./Audits.jsx";

export class Locations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            CustomerTableView: true,
            selectedCustomer: {},
            auditid: "",
            selection: [],
            isLoading: false,
            locationsList: [],
            counts: {},
            templates: []
        };
    }
    componentDidMount() {
       
        this.setState({ isLoading: true });
        let templateId = this.props.selectedTemplate._id;
        this.setState({ templates: this.props.selectedTemplate })
        this.props.fetchDTCMasterAction({
            templateId,
            onSuccess: (res) => {
        
                this.setState({ isLoading: false, locationsList: res.locations });
            },
            onFailure: () => {
                this.setState({ isLoading: false });
            },
        });
    }
    auditIdFromOlaAudit = (auditId) => {
        this.setState({
            auditid: auditId,
        });
    };

    dtchandleTableViewAuditClick = (customer) => {
        this.setState({ selectedCustomer: customer, CustomerTableView: false });
    };

    onGotoCustomerView = () => {
        this.setState({
            CustomerTableView: true,
        });
    };
    render() {
        
        const olaCol = this.props.auth.role == 'admin' ?
         [
            {
                title: "Distributor Name",
                field: "code",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.dtchandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.distributorName}
                    </span>
                ),
                customFilterAndSearch: (term, rowData) =>
                    rowData.distributorName.toLowerCase().indexOf(term.toLowerCase()) > -1,
            },
            {
                title: "Parking Location",
                field: "",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.dtchandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.parkingLocation}
                    </span>
                ),
                customFilterAndSearch: (term, rowData) =>
                    rowData.parkingLocation.toLowerCase().indexOf(term.toLowerCase()) > -1,
            },
            {
                title: "Zone",
                field: "",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.dtchandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.zone}
                    </span>
                ),
                customFilterAndSearch: (term, rowData) =>
                    rowData.zone.toLowerCase().indexOf(term.toLowerCase()) >
                    -1,
            },
            {
                title: "Auditor Name",
                field: "",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.dtchandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.auditor_details ? rowData.auditor_details.displayName : ''}
                    </span>
                ),
                
            },
            {
                title: "Employee Code",
                field: "",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.dtchandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.auditor_details ? rowData.auditor_details.employeCode : ''}
                    </span>
                ),
            },
        ] : [{
            title: "Distributor Name",
            field: "code",
            render: (rowData) => (
                <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        this.dtchandleTableViewAuditClick(rowData);
                    }}
                >
                    {rowData.distributorName}
                </span>
            ),
            customFilterAndSearch: (term, rowData) =>
                rowData.distributorName.toLowerCase().indexOf(term.toLowerCase()) > -1,
        },
        {
            title: "Parking Location",
            field: "",
            render: (rowData) => (
                <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        this.dtchandleTableViewAuditClick(rowData);
                    }}
                >
                    {rowData.parkingLocation}
                </span>
            ),
            customFilterAndSearch: (term, rowData) =>
                rowData.parkingLocation.toLowerCase().indexOf(term.toLowerCase()) > -1,
        },
        {
            title: "Zone",
            field: "",
            render: (rowData) => (
                <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        this.dtchandleTableViewAuditClick(rowData);
                    }}
                >
                    {rowData.zone}
                </span>
            ),
            customFilterAndSearch: (term, rowData) =>
                rowData.zone.toLowerCase().indexOf(term.toLowerCase()) >
                -1,
        },]

        return (
            <div>
                <NotificationContainer />
                {this.state.CustomerTableView && (
                    <div>
                        <div style={{ display: "inline-block", marginBottom: 20 }}>
                            <IconPicker
                                name="arrow left"
                                click={this.props.onClose}
                                styles={{
                                    color: getTextColor(this.props.color),
                                    float: "right",
                                    cursor: "pointer",
                                    marginTop: 35,
                                    position: "absolute",
                                    right: 20,
                                }}
                            />
                            <h1
                                style={{
                                    display: "inline-block",
                                    color: getTextColor(this.props.color),
                                }}
                            >
                                DTC Locations
                            </h1>

                        </div>
                    </div>
                )}
                {this.state.CustomerTableView && (
                    <div
                        style={{
                            display: "flex",
                            flexGrow: 1,
                            flexFlow: "column",
                            marginTop: 20,

                        }}
                    >
                        <TableView
                            data={this.state.locationsList}
                            columns={olaCol}
                            load={this.state.isLoading}
                        />

                    </div>
                )}

                {!this.state.CustomerTableView && (
                    <div style={{ flexGrow: 1, display: "flex" }}>
                        <Audits
                            template={this.state.templates}
                            customer={this.state.selectedCustomer}
                            onClose={this.onGotoCustomerView}
                            auditId={this.auditIdFromOlaAudit}
                            color={this.props.color}
                        />
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchDTCMasterAction
        },
        dispatch
    );
};
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Locations)
);
